import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  PettyCash,
  AddPettyCash,
  EditPettyCash,
  DetailPettyCash,
  ApprovalPettyCash,
} from "./pages";

const pettyCashRoutes = [
  {
    path: "/finance/petty-cash",
    element: (
      <ProtectedRoute name="petty_cash">
        <PettyCash />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="pettyCash.petty_cash" />,
  },
  {
    path: "/finance/petty-cash/add",
    element: (
      <ProtectedRoute name="petty_cash">
        <AddPettyCash />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="pettyCash.add_petty_cash" />,
  },
  {
    path: "/finance/petty-cash/detail/:id",
    element: (
      <ProtectedRoute name="petty_cash">
        <DetailPettyCash />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="pettyCash.detail_petty_cash" />
    ),
    children: [
      {
        path: "/finance/petty-cash/detail/:id/approval",
        element: <ApprovalPettyCash />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/finance/petty-cash/edit/:id",
    element: (
      <ProtectedRoute name="petty_cash">
        <EditPettyCash />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="pettyCash.edit_petty_cash" />
    ),
  },
];

export default pettyCashRoutes;
